<ul>
  <li
    *ngFor="let card of paymentCards; let i = index"
    [style]="getCardBrandColors(card.brand)"
    (click)="selected.emit(card)"
    [ngClass]="{ selected: cardSelected?.id === card.id }"
  >
    <ng-container>
      @if(canDeleteCard) {
      <div class="remove-card" (click)="removeCard($event, card)">
        Borrar
      </div>
      }
    </ng-container>
    <div class="number">**** **** **** {{ card.last4 }}</div>
    <div class="holder-expiration">
      <span class="holder">{{ card.holder }}</span> <span class="expiration">{{ card.expiration }}</span>
    </div>
  </li>
</ul>
